module.exports = __webpack_public_path__ + "static/media/logo.5aaa41c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo.png
// module id = 250
// module chunks = 0